export default "__VITE_ASSET__DRqNxxZV__"